import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IGroup } from '../../../ts/ServerApi/types/IGroup';
import { ITypedIdWithName } from '../../../ts/ServerApi/types/ITypedId';
import { ITypedIds } from '../../../ts/ServerApi/types/ITypedIds';
import { IUser } from '../../../ts/ServerApi/types/IUser';
import { IAuthorizableGranteePermissions } from '../types/IAuthorizableGranteePermissions';

export interface IGetExplicitPermissionsParams {
  authorizables: ITypedIds;
}

export interface IGetExplicitPermissionsResult extends IResult {
  permissions: IAuthorizableGranteePermissions[];
  groups: IGroup[];
  users: IUser[];
  sourceAuthorizableById?: _.Dictionary<ITypedIdWithName>;
}

export class GetExplicitPermissionsRequest extends Request<IGetExplicitPermissionsParams, IGetExplicitPermissionsResult> {
  constructor(params: IGetExplicitPermissionsParams) {
    super('getExplicitPermissions', params);
  }
}
